import { SERVICES_OPTIONS } from '../flow/checkboxOptions';
import { MatcherGenericCheckboxStep } from '../components';

function MatcherServicesStep() {
  return (
    <MatcherGenericCheckboxStep
      questionId="services"
      title="How can a tax pro help you?"
      options={SERVICES_OPTIONS}
      stepName="matcher_services_step"
      showSkip={false}
    />
  );
}

export { MatcherServicesStep };
